import { Component, ChangeDetectionStrategy } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { UntypedFormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '../automation-wizard-panel.component'
import {
  guestCardNotificationMessages,
  userCardNotificationMessages,
} from '@tv3/containers/automations/automations-wizard/card/messages'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-card-automation-wizard',
  templateUrl: './card-automation-wizard.component.html',
  styleUrls: ['./card-automation-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.CreditCard

  guestNotificationMessages = guestCardNotificationMessages
  userNotificationMessages = userCardNotificationMessages
  constructor(protected fb: UntypedFormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)
    this.form.patchValue({ event: AutomationEventTypes.PaymentCardAccepted })
  }
}
